import { jsx as _jsx } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-components';
/**
 * Render the final JSX of CopilotChat
 */
export const renderCopilotChat_unstable = state => {
  assertSlots(state);
  // TODO Add additional slots in the appropriate place
  return /*#__PURE__*/_jsx(state.root, {});
};
//# sourceMappingURL=renderCopilotChat.js.map